var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vx-col w-full mb-base"})
}
var staticRenderFns = []

export { render, staticRenderFns }